export default "__VITE_ASSET__rsIh7E3A__"